module.exports = __webpack_public_path__ + "assets/img/3.0c05a485.jpg";